import { widont } from 'utils/typography';
import { DefaultBlockProps } from '../switchBlock/SwitchBlock';
import style from './StatsBlock.module.scss';

export type BlocksStatsType = DefaultBlockProps & {
  block_type: 'stats';
  text: string;
};

export const StatsBlock = (props: BlocksStatsType): JSX.Element | null => {
  return (
    <div className={`${style.container}  block-stats`}>
      <div dangerouslySetInnerHTML={{ __html: widont(props.text) }} />
    </div>
  );
};
